import { useCalendarBounds as n } from "./useCalendarBounds.js";
function o(a) {
  const [r] = n(a);
  return Array.from({ length: 42 }, (d, t) => r.add(t, "day"));
}
export {
  o as useCalendarDays
};
